// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productDimensions":"NibcJ"};